import { AuthClient } from "@/api/ApiClientBase";
import * as api from "../api/ApiClient";

export async function isFeatureFlagEnabled(featureFlag: string) {
    let auth_client = AuthClient.getInstance();
    auth_client.overrideEnsureToken = true;
    var client = new api.FeatureFlagClient(auth_client);
    return await client.getFeatureFlag(featureFlag);
}